import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_FRAGMENTS = "fragments";
const BASE_URL = "/api/fragments";

const FragmentsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const FRAGMENT_EMPTY = {title: "", html: ""};

export function useFragments() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_FRAGMENTS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...FragmentsQueryConfig
    });
    return {...result, fragments: result.data};
}


export function useFragment(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_FRAGMENTS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...FragmentsQueryConfig
    });
    return {...result, fragment: result.data};
}

export function useFragmentsMutations() {
    async function createFunction(fragment) {
        if (!fragment) return;
        return await fetchPOST(BASE_URL, fragment, false);
    }

    async function editFunction(fragment) {
        if (!fragment) return;
        return  await fetchPUT(`${BASE_URL}/${fragment.id}`, fragment);
    }

    async function editAddNewFiles(fragment) {
        if (!fragment) return;
        return await fetchPUT(`${BASE_URL}/${fragment.id}/files`, fragment.filesIds);
    }

    async function deleteFunction(fragment) {
        return await fetchDELETE(`${BASE_URL}/${fragment.id}`)
    }

    return {
        createFragment: useMyMutation(createFunction, REACT_QUERY_ID_FRAGMENTS, fragment => `Album ${fragment.title} created`),
        editFragment: useMyMutation(editFunction, REACT_QUERY_ID_FRAGMENTS, fragment => `Album ${fragment.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_FRAGMENTS, fragment => `Album ${fragment.title} modified`),
        deleteFragment: useMyMutation(deleteFunction, REACT_QUERY_ID_FRAGMENTS, fragment => `Album ${fragment.title} deleted.`)
    };

}